import get from 'lodash/get';
import reduce from 'lodash/reduce';
import { EIncludedType } from '../member/member.types';
import { IApiMainScore } from '../score/score.types';
import {
  IApiInteraction,
  IApiInteractionRelationships,
  IApiInteractionResult,
} from './interaction.types';

export const getRelationships = (
  relationships?: IApiInteractionRelationships
) =>
  reduce<IApiInteractionRelationships, string[]>(
    relationships,
    (acc, value) =>
      value && value.data && value.data.id ? acc.concat(value.data.id) : acc,
    []
  );

export const interactionSerializer = (
  apiInteraction: IApiInteraction,
  parent: IApiInteractionResult
) => {
  const { relationships } = apiInteraction;
  const relationshipsID = getRelationships(relationships);
  const memberIncluded = relationshipsID.map((id: string) =>
    parent.included.find((current: IApiMainScore) => current.id === id)
  );
  const scoreFiltered = memberIncluded.find(
    (current: IApiMainScore) => current.type === EIncludedType.SCORE
  ) as IApiMainScore;
  const mainPicture =
    get(relationships, 'mainPicture.data.id') ||
    get(relationships, 'picture.data.id');

  return {
    id: apiInteraction.id,
    attributes: {
      score: scoreFiltered.attributes?.score,
      mainPicture,
    },
  };
};
